import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IAppServiceLanguages} from '@app/app.interface';
import {NotifierService} from '@services/notifier.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {InterfaceAccessMatrixUnit} from '@modules/login/interfaces/login.interface';
import {AppHelper} from '@app/core/app.helper';
import {CatalogsService} from '../../catalogs.service';

@Component({
  selector: 'app-catalog-dialog',
  templateUrl: './catalog-dialog.component.html',
  styleUrls: ['./catalog-dialog.component.css']
})
export class CatalogDialogComponent implements OnInit {
    /**
     * Объект формы
     */
    form: FormGroup = null;
    /**
     * Ссылка на объект формы
     */
    @ViewChild('formRef', {static: true}) formRef: ElementRef;
    /**
     * Текущий язык формы
     */
    currentLangForm: IAppServiceLanguages = {};
    /**
     * Инициализация формы
     */
    formInit: boolean = false;
    /**
     * Список мультиязычных полей форм
     */
    languageFormFields = [
        {name: 'name', required: true},
        {name: 'full_name', required: false}
    ];

    /**
     * Конструктор
     * @param formBuilder создатель форм
     * @param appService сервис взаимодействия с внешними ресурсами
     * @param notifier сервис всплывающих сообщений
     * @param spinner прелоадер
     * @param dialogRef ссылка на диалог
     * @param data данные для диалога
     */
    constructor(
        private formBuilder: FormBuilder,
        public appService: CatalogsService,
        public notifier: NotifierService,
        public spinner: NgxSpinnerService,
        public dialogRef: MatDialogRef<CatalogDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string;
            data: any;
            access: InterfaceAccessMatrixUnit;
        }) {
        this.currentLangForm = AppHelper.getCurrentLanguage(this.appService);
    }

    /**
     * Событие окончания инициализации компонента
     */
    ngOnInit() {
        this.initForm(this.data.data);
    }

    /**
     * Установить язык ввода
     * @param lang объект языка
     */
    setCurrentLangForm(lang: IAppServiceLanguages) {
        this.currentLangForm = lang;
    }


    /**
     * Инициализация формы
     * @param data данные записи
     */
    initForm(data: any) {
        this.form = this.formBuilder.group({
            id: [data?.id ? data.id : null, []],
            parent_id: [data?.parent_id ? data.parent_id : null, []],
        });
        this.languageFormFields.forEach(field => {
            let formGroup = this.formBuilder.group({});
            this.form.addControl(field.name, formGroup);
            AppHelper.createLangField(this.appService, this.formBuilder, formGroup, field.name, data, field.required);
        });
        this.formInit = true;
        setTimeout(() => {
            AppHelper.focusInput(this.formRef.nativeElement.querySelector('.mat-form-field'));
        }, 0);
        this.form?.get(`name.${this.currentLangForm.lang}`).setValue(data.valueFromSearch);
    }

    /**
     * Обработка события нажатия на Enter
     * @param event объект события
     */
    keyDownFunction(event): void {
        if (event.code == 'Enter') {
            this.save();
        }
    }

    /**
     * Сохранение данных
     */
    save() {
        if (this.form.valid) {
            let data = Object.assign({}, this.form.value);
            data.is_folder = 0;
            this.spinner.show();
            this.appService.save(data).toPromise().then((result: any) => {
                this.spinner.hide();
                if (result && result.is_error == false) {
                    this.dialogRef.close({
                        save: true,
                        data: result.data
                    });
                } else if (result.data.hasOwnProperty('lang')) {
                    result.data.lang.forEach((lang) => {
                        AppHelper.setErrorField(this.form.get('name.' + lang), result?.data?.valid_message);
                    });
                    AppHelper.validateAllFormFields(this.form);
                    setTimeout(() => {
                        const target = this.formRef?.nativeElement?.querySelector('.mat-select.ng-invalid, .mat-input-element.ng-invalid, .mat-checkbox-input.ng-invalid');
                        AppHelper.focusInput(target);
                    }, 0);
                }
            }).catch((error) => {
                this.spinner.hide();
                this.notifier.notify('error', error?.error?.message ?? this.appService.language_dictionary.system_no_connection_with_system);
            });
        } else {
            AppHelper.validateAllFormFields(this.form);
            setTimeout(() => {
                const target = this.formRef.nativeElement.querySelector('.mat-select.ng-invalid, .mat-input-element.ng-invalid, .mat-checkbox-input.ng-invalid');
                AppHelper.focusInput(target);
            }, 0);
        }
    }

    /**
     * закрытие диалога
     */
    close() {
        this.dialogRef.close({save: false});
    }
}
